<template>
  <div class="row">
    <div class="col-12"></div>

    <div class="col-8">
      <div class="row">
        <div class="col-12">
          <ul>
            <li  @mouseover="showContent($event,item)">
              <a :href="item.url">{{fetchLinkName(item)}}</a>
            </li>
          </ul>
        </div>
        <div class="col-6">
          <ul class="border-top">
            <li @mouseover="showLevel3Items($event,subitem)"
                v-for="subitem in item.subMenu" :key="subitem.id" >
              <a v-bind:href="subitem.url"
                 :class="[subitem.active? activeLinkClass : '', subitem.current? currentLinkClass : '', subitem.hasSub?'has-sub':'', subitem.hasActiveSub? 'active-sub-level':'']">
                <span >{{ subitem.name }}</span>
              </a>
            </li>
          </ul>
        </div>
        <div class="col-6">
          <ul :class="[isLevel3Active? 'border-top':'']">
            <li @mouseover="showContent($event,level3Item)"
                v-for="level3Item in level3Items" :key="level3Item.id" >
              <a :href="level3Item.url">
                <span >{{ level3Item.name }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <a :href="subContent.url" class="col-4 nav-teaser">
      <div class="nav-teaser-content">
        <div class="nav-teaser-image">
          <img :src="subContent.image">
        </div>
        <h3>{{subContent.header}}</h3>
        <p v-html="replace(subContent.text)"></p>
      </div>
      <span class="cta-button"><i class="icon-chevron-right" aria-hidden="true"></i></span>
    </a>
  </div>
</template>

<script>
export default {
  name: "Version0",
  props: {
    item:{}
  },
  data() {
    return {
      activeLinkClass:'active',
      currentLinkClass:'current',
      level3Items:[],
      isLevel3Active:false,
      activeSubMenu:{},
      subContent:{}
    }
  },
  methods: {
    showLevel3Items(event,subItem){
      this.item.subMenu.map((subitem)=>{
        subitem.hasActiveSub=false;
        return subitem;
      });

        if (subItem.hasSub){
          subItem.hasActiveSub = true;
          this.level3Items = subItem.subMenu;
          this.isLevel3Active = true;
          this.activeSubMenu = subItem;
        } else {
          this.level3Items =[];
          this.isLevel3Active = false;
          this.activeSubMenu = {uid:0};
        }
        this.subContent = subItem;
    },
    showContent(event,subItem){
      subItem.text.replaceAll('\r\n','<br />');
      this.subContent = subItem;
    },
    replace(text){
       return text.replaceAll('\r\n','<br />');
    },
    fetchLinkName(item){
      if (item.subtitle!==''){
        return item.subtitle;
      }
      return item.name;
    },
  },
  beforeMount(){

    this.item.subMenu.map((subitem)=>{
      subitem.hasActiveSub=false;
      return subitem;
    });
    this.subContent = this.item;


  }
}
</script>

<style scoped>

</style>
